import { render, staticRenderFns } from "./incident_master.vue?vue&type=template&id=01921252&scoped=true"
import script from "./incident_master.vue?vue&type=script&lang=js"
export * from "./incident_master.vue?vue&type=script&lang=js"
import style0 from "./incident_master.vue?vue&type=style&index=0&id=01921252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01921252",
  null
  
)

export default component.exports